import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import ImageUploader from '../../../components/ImageUploader';
import userService from '../../../services/userService.js';
import UserImage from '../../../assets/images/user-img.png';
import UserRolesComboBox from '../../../components/UserRolesComboBox';
import NotificationsSettings from '../../../components/UserSettings/NotificationsSettings';
import MarketComboBox from '../../../components/MarketComboBox';
import helper from '../../../helpers/misc-functions.js';
import dataModel from '../../../models/DataModel';
import PasswordSecurity from '../../../components/PasswordSecurity';
import PhoneInput from '../../../components/PhoneInput';
import MarketsCollection from '../../../dao/collections/MarketsCollection';
import TabbedPageControl from '../../../components/TabbedPageControl';
import CloseButton from '../../../components/Buttons/CloseButton/index.js';
import './UserPopup.scss';
import Input from '../../../components/Input/index.js';

export class UserPopup extends BaseComponent {

  constructor(props) {
    super(props);

    if (this.props.user) {
      let editUser = Object.assign({}, this.props.user);
      editUser.password = '';
      this.state = {
        editUser: editUser,
        originalUser: Object.assign({}, this.props.user),
        editing: true,
        suspendPopup: null,
        selectedTabName: this.textMap.info,
      };
  
    } 
    else {
      let editUser = {
        first_name: '', last_name: '', role: null, title: '', phone: '', email: '',
        profile_image: '', suspended: null, password: '',
      };
      this.state = {
        editUser: editUser,
        editing: true,
        selectedTabName: this.textMap.info,
      };
    }
    this.tabs = [this.textMap.info, this.textMap.notifications];
    if(props.permissions.isSuperUser) {
      this.tabs.push(this.textMap.security);
    }

    this.match = true;
    this.handleFocus = this.handleFocus.bind(this);
    this.marketsCollection = MarketsCollection.build(props.currentUser.id, props.currentCompany.id);
  }

  componentDidMount() {
    const editedUser = Object.assign({}, this.state.editUser, this.props.user.role);
  
    this.setState({ editUser: editedUser, originalUser: Object.assign({}, this.props.user) });
    this.marketsCollection.fetchCurrent().then(marketCollection => {
      this.setState({ markets: marketCollection });
    });
  }

  componentDidUpdate(){
    const { editUser } = this.state;
    if(editUser && this.props.user && editUser.profile_image !== this.props.user.profile_image){
      let updateEditUser = Object.assign({}, editUser);
      updateEditUser.profile_image = this.props.user.profile_image;
      this.setState({ editUser: updateEditUser });
    }
  }
  handleScrollTop(element){
    if (element){
      element.scrollTop = 0;
    }
  }

  handleCropModal(file, type) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
        displayPopup: 'cropper',
        currentAction: type,
      });
    };
  }

  handleFirstNameChange(e) {
    let editedUser = Object.assign({}, this.state.editUser, { first_name: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.first_name = e.target.value;
  }

  handleLastNameChange(e) {
    let editedUser = Object.assign({}, this.state.editUser, { last_name: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.last_name = e.target.value;
  }

  handleEmailChange(e){
    let editedUser = Object.assign({}, this.state.editUser, { email: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.email = e.target.value;
  }

  handleEmailUpdate(e) {
    userService.checkEmailAvailability(this.state.editUser.email).then((res) => {
      if (res.message == 'email already exists') {
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'A user is already associated with this email: '+ this.state.editUser.email,
          okButtonText: 'OK',
          width: 320,
          height: 182,
          oneButton: true,
          handleOwnerOk: () =>  {
            let editedUser = Object.assign({}, this.state.editUser, { email: this.state.originalUser.email });
            this.setState({ editUser: editedUser });
          },
        });
      }
    });
  }

  handleFormatPhone(phone){
    if(phone){
      if(phone.substring(0,2) == '1+'){
        phone = phone.slice(2);
        phone = phone.replace(/\D/g,'');
      }
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
  }

  handlePhoneChange(phone) {    
    if (phone == '') {
      phone = null;
    }
    let editedUser = Object.assign({}, this.state.editUser, { phone: phone });
    this.setState({ editUser: editedUser });
    this.props.user.phone = phone;
  }

  // handleDirectoryChange(directory){
  //   let editedUser = Object.assign({}, this.state.editUser, { directory: directory })
  //   this.setState({ editUser: editedUser })
  //   this.props.user.directory = directory
  // }

  handleMarketChange(markets){
    let editedUser = Object.assign({}, this.state.editUser, { markets: markets });
    this.setState({ editUser: editedUser });
    this.props.user.markets = markets;
  }

  handleRoleChange(role) {
    let editedUser = Object.assign({}, this.state.editUser, {
      role: role,
    });
    this.setState({ editUser: editedUser });
    this.props.user.role = role;
  }

  handleTitleChange(e){
    let editedUser = Object.assign({}, this.state.editUser, { title: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.title = e.target.value;
  }

  handlePasswordChange(e){
    let editedUser = Object.assign({}, this.state.editUser, { password: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.password = e.target.value;
    this.handleCheckPasswords(editedUser.password, editedUser.password_confirmation, 'pass');
  }

  handleConfirmPasswordChange(e){
    let editedUser = Object.assign({}, this.state.editUser, { password_confirmation: e.target.value });
    this.setState({ editUser: editedUser });
    this.props.user.confirmPassword = e.target.value;
    this.handleCheckPasswords(editedUser.password, editedUser.password_confirmation, 'conf');
  }

  handleDisabledChange(e){
    let originalUser = Object.assign({}, this.state.editUser);
    let editedUser = Object.assign({}, this.state.editUser, { suspended: !e, previous_suspended: e });

    // Add props to set state 
    if(editedUser.suspended != originalUser.suspended){
      if(this.props.handleToggleSuspension){
        this.props.handleToggleSuspension(editedUser);
      }
    }

    this.setState({ editUser: editedUser });
  }

  handleCheckPasswords(pass, conf, type){
    this.match = false;
    this.props.confirmPasswords(false);

    if (pass == conf && pass.length >= 8) {
      this.match = true;
      this.props.confirmPasswords(true);
    } else if ((pass == '' && conf == '') || (!pass && conf == '') || (pass == '' && !conf)) {
      this.match = false;
      this.props.confirmPasswords(null);
    }
  }

  handleFocus(e){
    if (e) {
      document.getElementById(e.target.id).focus();
    }
  }

  handleSelectTab(tabName) {
    this.setState({ selectedTabName: tabName });
  }

  handleCreatePopup(profileUrl, defaultRole, marketSelection){
    let popupBody;
    let phone = '';
    if (this.state.selectedTabName == this.textMap.info) {
      if (this.state.editUser.phone) {
        phone = this.handleFormatPhone(this.state.editUser.phone);
      }
  
      let marketCombo = <div className='market field'>  
        <MarketComboBox 
          handleSelectMarket={this.handleMarketChange}
          markets={this.state.markets}
          height={32}
          width={219}
          hasBorder={false}
          multiSelect={true}              
          defaultText={this.textMap.markets}
          displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '10px', marginTop: '11px' }}
          currentOption={marketSelection}
        />
      </div>;
      if (this.props.isVendor) {
        marketCombo = null;
      }

      popupBody = (
        <div id='popup-body' className='popup-body' ref={element => { this.handleScrollTop(element); }}>
          <Input className="input-field field" id="first-name" value={this.state.editUser.first_name ? this.state.editUser.first_name : ''} placeholder={this.textMap.firstName} onClick={this.handleFocus} onChange={this.handleFirstNameChange}
            onBlur={this.handleFirstNameChange} />
          <Input className="input-field field" id="last-name" value={this.state.editUser.last_name ? this.state.editUser.last_name : ''} placeholder={this.textMap.lastName} onClick={this.handleFocus} onChange={this.handleLastNameChange}
            onBlur={this.handleLastNameChange} />
          <Input className="input-field field" id="title" value={this.state.editUser.title ? this.state.editUser.title : ''} placeholder={this.textMap.title} onClick={this.handleFocus} onChange={this.handleTitleChange}
            onBlur={this.handleTitleChange} />
          <Input className="input-field field" id="email" value={this.state.editUser.email ? this.state.editUser.email : ''} placeholder={this.textMap.email} onClick={this.handleFocus} onChange={this.handleEmailChange} />
          <PhoneInput
            classNameInput={'input-field field'}
            idInput={'phone'}
            inputValue={phone}
            inputPlaceholder={this.textMap.phone}
            handlePhoneChange={this.handlePhoneChange}
            handleFocus={this.handleFocus}
          />
          <div className="user-roles field">
            <UserRolesComboBox height={32} width={219} hasBorder={false} defaultText={this.textMap.permission}
              displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '10px', marginTop: '11px' }}
              handleRoleChange={this.handleRoleChange} currentOption={defaultRole} admin={this.props.admin} targetUser={this.state.originalUser}/>
          </div>
          {marketCombo}
        </div>
      );
    }
    else if(this.state.selectedTabName == this.textMap.notifications){
      let flattenedDirectories = [];
      helper.handleFlattenDirectories(this.props.directories, flattenedDirectories);
      popupBody = (
        <div className='popup-body'>
          <span className='notifications-header'>EMAIL NOTIFICATIONS</span>
          <NotificationsSettings
            notificationType='profile_email_notifications'
            settingsKey='email_notifications'
            userToUpdate={this.props.user}
            headerText={this.textMap.receiveEmailNotifications}
            descriptionText={this.textMap.receiveEmailNotificationsDescription}
          />
        </div>
      );
    }
    else if(this.state.selectedTabName == this.textMap.security) {
      popupBody = (
        <div className='popup-body'>
          <Input className="input-field field"
            type='password' id="password"
            value={this.state.editUser.password ? this.state.editUser.password : ''}
            placeholder={this.textMap.password}
            onClick={this.handleFocus}
            onChange={this.handlePasswordChange}
            onPaste={e => e.preventDefault()}
            />
          <PasswordSecurity 
            password1={this.state.editUser.password ? this.state.editUser.password : ''}
            containerWidthClass={'--popup'}
            updatePasswordStrength={this.updatePasswordStrength}
          />
          <Input className="input-field field"
            type='password'
            id="confirm-password"
            value={this.state.editUser.password_confirmation ? this.state.editUser.password_confirmation : ''}
            placeholder={this.textMap.confirmPassword}
            onClick={this.handleFocus}
            onChange={this.handleConfirmPasswordChange}
            onPaste={e => e.preventDefault()}
            />
        </div>
      );
    }
    return (
      <div>
        <ImageUploader cropFile={this.props.file} file={profileUrl} handlePickPhoto={this.props.handleCropModal} type={this.props.type}
        height={114} width={114} top={-112} left={145} borderRadius={60} defaultImage={UserImage} imageTop={70} />
        {this.props.imageRemoveButton &&
         <CloseButton 
            className="profile-close-button"
            left={250}
            width={15}
            height={15}
            top={-115}
            fillColor="#ffffff"
            borderColor="#ffffff"
            hasShadow={false}
            handleClick={this.props.imageRemoveButton} 
          />
        }
        <TabbedPageControl 
          tabItems={this.tabs} 
          selectedTabName={this.state.selectedTabName}
          handleClick={this.handleSelectTab}
        />
        {popupBody}
      </div>
     );
  }

  render() {

    let profileUrl;
    let defaultRole;
    if(this.state.editUser.profile_image) {
      profileUrl = this.state.editUser.profile_image;
    }
    if(this.state.editUser.role){
      defaultRole = { type: this.state.editUser.role.id, role: this.state.editUser.role, name: this.state.editUser.role.description };
    }

    return (
      <div id={this.props.id} className="user-popup" >
        {this.handleCreatePopup(profileUrl, defaultRole, this.state.editUser.markets)}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
  };
};

export default connect(mapStateToProps)(UserPopup);



// WEBPACK FOOTER //
// ./src/containers/Directory/UserPopup/index.js